module.exports = __webpack_public_path__ + "img/left_gray.68416bf7.svg";